const BG_IMG_PATH =
  "resources/images/high-yield-cash/high-yield-cash-enrollment-background.svg";

export const BlueLinesBackground = () => (
  <div
    className={`fixed top-0 left-0 z-0 flex h-full w-full justify-center bg-[url(${BG_IMG_PATH})] bg-contain bg-repeat-y md:bg-cover md:bg-no-repeat`}
  />
);
